'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  withPropsOnChange 每次依 props 判斷要不要重新產生 formatter
  withhandlers 為每次 render 都重新產生 func，但只是把 props 包進 closure
  產生一個 func 與 判斷 props 是否一致，兩者不知道效率的差異
  感覺 withHandlers 好像比較好一些

  因為共用 doc state，沒做 shouldUpdate 時每個改動，所有 input 都會重 render
  */

var creator = {
  default: function _default() {
    return function defaultParser(value) {
      return value;
    };
  },
  number: function number() {
    return function numberParser(value) {
      return +value;
    };
  },
  date: function date(_ref) {
    var parseFormat = _ref.parseFormat;
    return function dateParser(value) {
      var date = (0, _moment2.default)(value, parseFormat);

      // ISSUE use moment as date value
      return date.toDate();
      // return date.isValid() ? date.toDate() : null
    };
  },
  boolean: function boolean() {
    return function booleanParser(value) {
      var asTrue = ['true', 'TRUE', '1'];
      if (asTrue.includes(value)) return true;
      var asFalse = ['false', 'FALSE', '0'];
      if (asFalse.includes(value)) return false;

      return !!value;
    };
  },
  array: function array(spec) {
    return function arrayParser(value) {
      var _spec$elementType = spec.elementType,
          elementType = _spec$elementType === undefined ? 'default' : _spec$elementType;


      var parserCreator = creator[elementType.toLowerCase()] || creator.default;
      var parser = parserCreator(spec);

      return value.split(',').map(parser);
    };
  }
};

function trim(value) {
  return typeof value === 'string' ? _ramda2.default.trim(value) : value;
}
function shouldBeNull(value) {
  if (_ramda2.default.isNil(value)) return true;
  if (value === '') return true;
  return false;
}
function makeParser(spec) {
  var _spec$type = spec.type,
      type = _spec$type === undefined ? 'default' : _spec$type;


  var parserCreator = creator[type.toLowerCase()] || creator.default;

  var typeParser = parserCreator(spec);
  return function parser(value) {
    return _ramda2.default.pipe(trim, _ramda2.default.ifElse(shouldBeNull, _ramda2.default.always(null), typeParser))(value);

    // const trimedValue = trim(value)
    // if (shouldBeNull(trimedValue)) return null
    // return parseByType(trimedValue)
  };
}

var specKeys = ['type', 'parseFormat', 'elementType'];
function isEqualSpec(a, b) {
  for (var i = 0; i < specKeys.length; i++) {
    if (a[specKeys[i]] !== b[specKeys[i]]) return false;
  }
  return true;
}

makeParser.isEqualSpec = isEqualSpec;
makeParser.specKeys = specKeys;
exports.default = makeParser;


//////////////////
// WEBPACK FOOTER
// ./~/coact/utils/makeParser/index.js
// module id = 1688
// module chunks = 0